module.exports = __webpack_public_path__ + "img/16.e1b9ada4.jpg";